<template>
  <div v-if="isVisible" class="full-screen-loading" >
    <div class="loading-content"></div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
const isVisible = ref(true); // 控制加载动画的显示与隐藏
</script>

<style scoped lang="scss">
.full-screen-loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999; /* 确保它在最上层 */
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--theme-pwa-bg, var(--theme-primary-dark, #151a1f)); /* 优先使用主题PWA背景色，回退到主题主色，最后回退到默认色 */
  color: #fff; /* 加载文字颜色 */
  backdrop-filter: blur(5px); /* 模糊背景，可选，需要浏览器支持 */
  -webkit-backdrop-filter: blur(5px); /* 适配 Safari */
}

.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px; /* 间隔 */
}

.loading-text {
  font-size: 16px;
  color: #fff;
}

/* Vue Transition 动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
